// extracted by mini-css-extract-plugin
export var container = "_5n-0";
export var disabled = "_5n-4";
export var fullWidth = "_5n-3";
export var lined = "_5n-1";
export var selected = "_5n-5";
export var tab = "_5n-2";